/**
 * 应用卡片分享
 */
import React, { useCallback, useMemo, useState } from "react";
import { JoySpaceDocumentMessage, SessionType } from "@/types/chat";
import { HeadShowType, MessageSendType } from "@/types/chat/enum";
import lodashGet from "lodash/get";
import lodashSet from "lodash/set";
import styles from "./index.module.less";
import HeadPortrait from "@/baseComponents/Chat/HeadPortrait";
import { openUserCardModal } from "@/components/AddressBook/common";
import Context from "@/components/chat/context";
import ChatState from "@/types/chat/State";
import { getTextMessageRemark } from "@/components/chat/utils/commonMessageModal";
import { connect } from "dva";
import Calendar from "./Calendar";
import ErrorComp from "@/components/ErrorHolder/ErrorComp";

function mapStateToProps({ chat }: { chat: ChatState }) {
  const { currentEmployee, selectedSession, connectState } = chat;
  return {
    userInfo: currentEmployee,
    currentEmployee,
    selectedSession,
    connectState
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    updateSessionMessageMid(data: { sendResult: any; sessionId: String, saveLocal?: string }) {
      dispatch({ type: "chat/updateSessionMessageMid", payload: data });
    }
  };
}

function MeetingScheduleCard(props: any) {
  const {
    currentEmployee,
    selectedSession,
    message,
    sessionType,
    sendType,
    updateSessionMessageMid
  } = props;
  const dataInfo = useMemo(() => {
    return lodashGet(message, "data.0.schedule", {});
  }, [message]);

  const handleSave = useCallback(
    (data: any) => {
      const { title, beginTime, participants } = data;
      const newMsg = JSON.parse(JSON.stringify(message));
      const schedule = {
        ...data,
        topic: title,
        startTime: beginTime,
        participant: participants
      };
      lodashSet(newMsg, "data.0.schedule", schedule);
      updateSessionMessageMid({
        sendResult: {
          body: newMsg
        },
        sessionId: selectedSession.sessionId,
        saveLocal: true
      });
    },
    [message, updateSessionMessageMid, selectedSession.sessionId]
  );
  return (
    <ErrorComp>
      <div className={`content ${styles["ai-meeting-schedule-wrap"]}`}>
        <div className={`card-container-app ${sendType === MessageSendType.OTHER ? "other" : ""}`}>
          <div
            className={`top-box ${selectedSession.isSecret ? "top-box_isSecret" : ""}`}
            dangerouslySetInnerHTML={{
              __html: getTextMessageRemark(selectedSession, message, currentEmployee, "", -1).trim()
            }}
          />
          <Calendar visible={true} calendarDetail={dataInfo} onSave={handleSave} />
        </div>
      </div>
    </ErrorComp>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(MeetingScheduleCard);
